import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { redirectToHostedUi } from '../auth/oidc';
import { consumeReturnTo } from '../auth/auth-401.interceptor';

/**
 * /login is a one-way redirect to Cognito's Hosted UI per
 * AUTH-REDESIGN-directives.md (Hosted UI is the SINGLE
 * credential-collection surface across the stack). The legacy
 * password form has been removed — no app collects passwords directly.
 */
@Component({
  selector: 'app-login',
  imports: [CommonModule],
  template: `
    <div class="grid place-items-center min-h-screen text-gray-300">
      <div class="text-center">
        <div class="text-sm">Redirecting to sign in…</div>
      </div>
    </div>
  `,
})
export class LoginComponent implements OnInit {
  async ngOnInit(): Promise<void> {
    // auth-401 interceptor stashes the pre-bounce path; honor it so the
    // user lands back where they were after re-auth instead of /home.
    await redirectToHostedUi(consumeReturnTo());
  }
}
